export const RentalHomePageTemplateData = {
  templateName: 'static-rental-taxi',
  metaTitle: 'Book Hourly Car Rental & Save Upto ₹200 Off - MakeMyTrip',
  metaDescription:
    'Choose from a wide variety of Cars - MakeMyTrip offers to use code:MMTRENTAL and Save Upto ₹200 Off to hire a car at your nearby location for best fares.',
  metaKeywords:
    'Hourly car rental, car rental near me, car rental services, car rental app, outstation car rental, booking car rental, monthly car rental',
  analytics: `var s=s_gi('mmtprod');
            s.pageName="seo:domestic cabs:RentalHome";
            s.channel="seotemplate domestic cabs funnel";
            s.server = window.location.hostname;
            s.prop24="domestic cabs";
            if(typeof(mboxLoadSCPlugin) != "undefined" ){
            mboxLoadSCPlugin(s);
            }
            var s_code=s.t();if(s_code)document.write(s_code);`,
  h1Title: 'Hourly Car Rental',
  extraInfo: '',
  bannerMobile: 'top',
  bannerDesktop: 'top',
  breadcrumb: [
    {
      displayString: 'Home',
      redirectionUrl: 'https://www.makemytrip.com/'
    },
    {
      displayString: 'Car Rental',
      redirectionUrl: 'https://www.makemytrip.com/car-rental/'
    }
  ],
  faq: [
    {
      question: `What are the payment options for hourly car rental ?`,
      answer: `You can complete the payment for your car rental using your debit/credit card. You can also use net banking, UPI, or your mobile wallet to complete the payment.`
    },
    {
      question: `Where do I submit my complaint/feedback about the car rental ?`,
      answer: `Once you have completed the trip, you can submit your feedback/complaint on the MakeMyTrip website or app after logging in to your account.`
    },
    {
      question: `Will the car rental arrive at the scheduled time?`,
      answer: ` The car rental will reach the designated pick up location at the time specified in your booking. There might be some delays due to extraordinary circumstances, but such delays are extremely rare. `
    }
  ],
  externalJs: '',
  sampleUrl: 'https://www.makemytrip.com/car-rental/',
  footerData: '', // update from response
  descriptionInHtml: `<h2>Online Hourly Car Rental on MakeMyTrip</h2> 

  <p>Hourly car rentals have become an increasingly popular option for those who need a car for a short period of time. Whether you need a car for just a few hours to run errands or for an entire day to explore a new city, hourly car rentals offer a flexible and convenient solution. An hourly  <strong>car rental</strong>  is also often a more cost-effective option than traditional car rentals. Because you only pay for the time you use, you can save money by returning the car as soon as you're finished with it. This is especially useful if you only need a car for a few hours or if you're only using it for a specific task, such as running errands or visiting a friend.</p> 
  
  <p>In addition to the flexibility and convenience they offer, an hourly <strong>car rental</strong>  can also be a more environmentally friendly option than the traditional  <strong>car rental</strong> model. By only using a car when you need it, you can reduce your carbon footprint and help protect the environment.</p> 
  
  <h2>Types of Car Rentals on MakeMyTrip</h2> 
  
  <p>MakeMyTrip understands your travel needs and offers car rentals that suit any and all <strong>car rental</strong> needs. You can book from the many options available on MakeMyTrip.</p> 
  
  <ul> 
  
  <li> Round-Trip: A round-trip  <strong>car rental</strong>  is one where you are picked up by a cab at your location of choice and return to it after your trip. To book a round-trip  <strong>car rental</strong> , you will typically need to provide your pick-up and drop-off dates. You will also need to choose the type of car you want to rent, such as a compact, mid-size, or full-size vehicle. </li> 
  
  <li> One-Way: With a one-way  <strong>self drive car rental</strong> , you can pick up a car at one location and drop it off at another. This is a good option for travellers who are planning a road trip or who need to travel between two different cities. Or you can get a regular  <strong>car rental</strong>  that will drop you off at your destination. </li> 
  
  <li> Outstation: Outstation  <strong>car rental</strong>  refers to a type of service that allows travellers to rent a car for a round trip or one-way trip between two different cities or locations. Outstation car rentals are a good option for travellers who are planning a long-distance road trip or who need to travel between two different cities for business or leisure. </li> 
  
  <li> Airport Transfers: Another popular  <strong>car rental</strong>  service is the airport transfer cab service. People regularly hire cabs when deboarding at airports to reach their destinations. Airport transfers offer transport options at much cheaper rates. You can also book an airport transfer to the airport at a pre-scheduled time and not miss your flight without being charged sky high rates. </li> 
  
  </ul> 
  
  <h2> Why Book a Car Rental with MakeMyTrip </h2> 
  
  <p> One of the main benefits of hourly  <strong>car rental services</strong>  is the flexibility they offer. With traditional car rentals, you typically have to commit to a minimum rental period of several days or even get a  <strong>monthly car rental</strong> . This can be inconvenient if you only need a car for a few hours or if your plans change unexpectedly. MakeMyTrip car rentals allow you to rent a car for as little as one hour at a time, so you only pay for the time you actually use. </p> 
  
  <p> Another advantage of an hourly  <strong>car rental</strong>  is the convenience it offers. Many  <strong>car rental app</strong>  companies offer pickup and drop-off services at various locations, making it easy to get a car when you need it and return it when you're done. Some companies even offer  <strong>outstation car rental</strong>  services with the car being delivered to your location. There are a few things to keep in mind when considering an hourly  <strong>car rental</strong> .&nbsp; </p> 
  
  <ol> 
  
  <li> Be sure to read the rental agreement carefully to understand the terms and conditions of the  <strong>car rental</strong> . This will help you avoid any unexpected fees or charges. </li> 
  
  <li> Be sure to check the insurance coverage provided by the rental company. Some hourly car rentals may not include insurance, so you may need to purchase additional coverage while  <strong>booking car rental</strong> . </li> 
  
  </ol> 
  
  <p> With MakeMyTrip, you don&rsquo;t have to worry about the fine print and can rest assured that there are no hidden charges and that your trip is insured. MakeMyTrip offers a secure, transparent, and accountable booking and  <strong>car rental</strong>  experience. In addition, you enjoy the best rates in the industry with great offers thanks to the numerous partnerships of MakeMyTrip, all geared towards giving you the best travel experience. </p> 
  
  <h2> How to Book a Car Rental on MakeMyTrip </h2> 
  
  <p> To book a  <strong>car rental</strong>  on MakeMyTrip, you need to follow these simple steps. </p> 
  
  <ol> 
  
  <li>Visit the MakeMyTrip website and log in to avail of great discounts and offers.</li> 
  
  <li>Click on Cabs to start the booking process for car rentals.</li> 
  
  <li>Select the type of  <strong>car rental</strong>  you are looking for: Outstation One-Way, Outstation Round Trip, Airport Transfers, Hourly Rentals.</li> 
  
  <li>Choose the pick-up and drop-off locations, date and time of your pick-up.</li> 
  
  <li>Click on search and choose from the available car types.</li> 
  
  <li>Click on the book now button to proceed with the payment and confirm your booking.</li> 
  
  </ol> 
  
  <p>You will receive your booking confirmation on your registered email, and mobile phone. You can also access your booking details from your MakeMyTrip profile on the website or on the MakeMyTrip mobile app.</p> 
  
   `
};
